import { consumerThemeConfig } from './consumer/config';
import { banffThemeConfig } from './banff/config';
import { banffConsumerThemeConfig } from './banff-consumer/config';
import { cortinaThemeConfig } from './cortina/config';
const defaultThemeConfig = {
  name: 'Enterprise'
};
export const themeList = [defaultThemeConfig, consumerThemeConfig, banffThemeConfig, banffConsumerThemeConfig, cortinaThemeConfig];
export default themeList;
export { defaultThemeConfig, consumerThemeConfig, banffThemeConfig, banffConsumerThemeConfig, cortinaThemeConfig };